var map = {
	"./icon-3d-model.svg": "./src/assets/icons/icon-3d-model.svg",
	"./icon-arrow--cta-long.svg": "./src/assets/icons/icon-arrow--cta-long.svg",
	"./icon-arrow--cta-short.svg": "./src/assets/icons/icon-arrow--cta-short.svg",
	"./icon-arrow--cta.svg": "./src/assets/icons/icon-arrow--cta.svg",
	"./icon-arrow--down.svg": "./src/assets/icons/icon-arrow--down.svg",
	"./icon-arrow--left.svg": "./src/assets/icons/icon-arrow--left.svg",
	"./icon-arrow--right.svg": "./src/assets/icons/icon-arrow--right.svg",
	"./icon-arrow--up.svg": "./src/assets/icons/icon-arrow--up.svg",
	"./icon-cart.svg": "./src/assets/icons/icon-cart.svg",
	"./icon-check--circle.svg": "./src/assets/icons/icon-check--circle.svg",
	"./icon-close.svg": "./src/assets/icons/icon-close.svg",
	"./icon-contact.svg": "./src/assets/icons/icon-contact.svg",
	"./icon-event--in-person.svg": "./src/assets/icons/icon-event--in-person.svg",
	"./icon-event--virtual.svg": "./src/assets/icons/icon-event--virtual.svg",
	"./icon-featured-product.svg": "./src/assets/icons/icon-featured-product.svg",
	"./icon-intro-block-bg.svg": "./src/assets/icons/icon-intro-block-bg.svg",
	"./icon-lock.svg": "./src/assets/icons/icon-lock.svg",
	"./icon-login.svg": "./src/assets/icons/icon-login.svg",
	"./icon-minus.svg": "./src/assets/icons/icon-minus.svg",
	"./icon-play.svg": "./src/assets/icons/icon-play.svg",
	"./icon-plus.svg": "./src/assets/icons/icon-plus.svg",
	"./icon-remove.svg": "./src/assets/icons/icon-remove.svg",
	"./icon-return.svg": "./src/assets/icons/icon-return.svg",
	"./icon-search.svg": "./src/assets/icons/icon-search.svg",
	"./icon-shipping.svg": "./src/assets/icons/icon-shipping.svg",
	"./icon-slider--yellow.svg": "./src/assets/icons/icon-slider--yellow.svg",
	"./icon-swiper-next.svg": "./src/assets/icons/icon-swiper-next.svg",
	"./icon-swiper-previous.svg": "./src/assets/icons/icon-swiper-previous.svg",
	"./icon-testimonial.svg": "./src/assets/icons/icon-testimonial.svg",
	"./icon-timeline.svg": "./src/assets/icons/icon-timeline.svg",
	"./icon-tooltip.svg": "./src/assets/icons/icon-tooltip.svg",
	"./icon-trail-marker.svg": "./src/assets/icons/icon-trail-marker.svg",
	"./icon-webinar.svg": "./src/assets/icons/icon-webinar.svg",
	"./social-icons/icon-facebook.svg": "./src/assets/icons/social-icons/icon-facebook.svg",
	"./social-icons/icon-instagram.svg": "./src/assets/icons/social-icons/icon-instagram.svg",
	"./social-icons/icon-linkedin.svg": "./src/assets/icons/social-icons/icon-linkedin.svg",
	"./social-icons/icon-pinterest.svg": "./src/assets/icons/social-icons/icon-pinterest.svg",
	"./social-icons/icon-rss.svg": "./src/assets/icons/social-icons/icon-rss.svg",
	"./social-icons/icon-shopify-logo.svg": "./src/assets/icons/social-icons/icon-shopify-logo.svg",
	"./social-icons/icon-snapchat.svg": "./src/assets/icons/social-icons/icon-snapchat.svg",
	"./social-icons/icon-tumblr.svg": "./src/assets/icons/social-icons/icon-tumblr.svg",
	"./social-icons/icon-twitter.svg": "./src/assets/icons/social-icons/icon-twitter.svg",
	"./social-icons/icon-vimeo.svg": "./src/assets/icons/social-icons/icon-vimeo.svg",
	"./social-icons/icon-youtube.svg": "./src/assets/icons/social-icons/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive \\.svg$";